import { apiDelete, apiFetch, apiPatch, apiPost } from '@/utils/fetchWrapper';
import { EstablishmentSettings } from '@/types/api';
import type { CallTerminationReasonCatalogItem } from '@/types/callTerminationReasons';
import { Establishment } from '@/types/nominals';

export const systemService = {
  async getEstablishment(establishmentId: number): Promise<Establishment> {
    return apiFetch<Establishment>(`/establishments/${establishmentId}/`);
  },

  async getEstablishments(): Promise<{
    count: number;
    results: Establishment[];
  }> {
    return apiFetch<{ count: number; results: Establishment[] }>(
      '/establishments/'
    );
  },

  async getCurrentEstablishmentSettings(): Promise<EstablishmentSettings> {
    return apiFetch<EstablishmentSettings>('/establishment-settings/');
  },

  async updateCurrentEstablishmentSettings(
    updates: Partial<EstablishmentSettings>
  ): Promise<EstablishmentSettings> {
    return apiPatch<EstablishmentSettings, Partial<EstablishmentSettings>>(
      '/establishment-settings/',
      updates
    );
  },

  async applyEstablishmentScheduleToNominals(): Promise<{
    nominals_updated: number;
  }> {
    return apiPost<{ nominals_updated: number }, Record<string, never>>(
      '/establishment-settings/apply-to-nominals/',
      {}
    );
  },

  async listTerminationReasons(): Promise<CallTerminationReasonCatalogItem[]> {
    const response = await apiFetch<{
      count: number;
      results: CallTerminationReasonCatalogItem[];
    }>('/termination-reasons/');
    return response.results;
  },

  async createTerminationReason(
    label: string
  ): Promise<CallTerminationReasonCatalogItem> {
    return apiPost<CallTerminationReasonCatalogItem, { label: string }>(
      '/termination-reasons/',
      { label }
    );
  },

  async updateTerminationReason(
    id: number,
    label: string
  ): Promise<CallTerminationReasonCatalogItem> {
    return apiPatch<CallTerminationReasonCatalogItem, { label: string }>(
      `/termination-reasons/${id}/`,
      { label }
    );
  },

  async deleteTerminationReason(id: number): Promise<void> {
    await apiDelete(`/termination-reasons/${id}/`);
  },
};
